import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function FinalCTA() {
  return <section className="bg-eq-navy px-3 py-3 text-white sm:px-4 sm:py-4" data-id="element-41" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-3xl text-center" data-id="element-42" data-mp="8573fjn5v7wu">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-43" data-mp="83m6xohadewc">
          One Last Opportunity
        </h2>
        <div className="mb-1.5 space-y-0.5 text-[12.5px] font-medium leading-snug text-white/80 sm:text-base" data-id="element-44" data-mp="h6napiioitwu">
          <p data-id="element-45" data-mp="vtgh1ya80pcw">
            Another rider. Another lesson. Another exercise to choose. Another progression to plan.
            Another session to prepare.
          </p>
          <p className="font-bold text-white" data-id="element-46" data-mp="14v6hftm2yymt">You can keep building everything from scratch…</p>
          <p className="font-extrabold text-eq-goldLight" data-id="element-47" data-mp="zwmxfyr1rwx3">
            Or open your system and start teaching.
          </p>
        </div>

        <a href={CHECKOUT_URL} className="mb-1.5 block" aria-label={`Buy ${PRODUCT_NAME}`} data-id="element-48" data-mp="2c5y8xkq9sdcb">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[200px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-49" data-mp="2h4j06unjnmom" />
        </a>

        <p className="font-display text-[19px] font-extrabold uppercase leading-none tracking-tight text-white sm:text-4xl" data-id="element-50" data-mp="2qzkr9w1dqytu">
          {PRODUCT_NAME}
        </p>
        <p className="mb-1 font-display text-[11px] font-bold uppercase text-eq-goldLight sm:text-base" data-id="element-51" data-mp="301apbkprow0l">
          Complete 6-in-1 Ready-to-Use Riding Instruction System + 5 Premium Bonuses
        </p>
        <p className="text-[12.5px] font-medium text-white/75" data-id="element-52" data-mp="39rvob99cs2k1">
          Regular Price: <span className="line-through" data-id="element-53" data-mp="3esjdrqhxobc5">{PRICE_FULL}</span>
        </p>
        <p className="mb-1.5 font-display text-[22px] font-extrabold uppercase leading-tight tracking-tight text-eq-goldLight sm:text-4xl" data-id="element-54" data-mp="3istspsnpec35">
          TODAY ONLY: {PRICE_TODAY}
        </p>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-1 max-w-md" data-id="element-55" data-mp="1ep8rxw65riaf">
          🚀 YES! I WANT HORSE RIDING INSTRUCTOR PRO™
        </CTAButton>

        <p className="text-[11px] font-bold text-white/85 sm:text-sm" data-id="element-56" data-mp="1shgiv7argf17">
          Immediate Access • Digital Delivery
        </p>
        <p className="text-[11px] font-bold text-white/85 sm:text-sm" data-id="element-57" data-mp="1nnu6lg8ied5x">
          ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews 🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}